// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"6bdabf50","599":"4edf7b9c","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};